import { createSlice } from "@reduxjs/toolkit";

const initialStateValue = { firstName: "", lastName: "", email: "", phone: 0, password: '', accept: '', }

export const userSlice = createSlice({
    name: "user",
    initialState: { value: initialStateValue },
    reducers: {
        signUp: (state, action) => {
            state.value = action.payload;
        },
    },
});

export const { signUp } = userSlice.actions;

export default userSlice.reducer;